import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsTriathlonNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M16 11.67a3.67 3.67 0 10-1.07-7.18l-1.48-2.82h1.59L14.33.33h-3.12l1.16 2.21h-2.212L9.7 1.67h.995L9.98.33H6.65l.72 1.34h.8l.747 1.4-.785 1.446a3.664 3.664 0 102.474 4.154h1.784a3.68 3.68 0 003.61 3zm0-6a2.34 2.34 0 11-1.62.67l.92 1.75h1.52l-1.25-2.38c.141-.029.286-.042.43-.04zm-2.91-1.78l.64 1.22a3.754 3.754 0 00-1.237 1.822L10.875 3.89h2.215zm-1.914 3.44H8.15L9.673 4.5l1.503 2.83zM7 10.316a2.326 2.326 0 01-1.366-4.205 2.325 2.325 0 011.848-.395L6.67 7.23l.73 1.44h1.812A2.319 2.319 0 017 10.316zm4 3.154a1.49 1.49 0 01-1.02.39A1.552 1.552 0 018.6 13H7.37l-.02.04a1.517 1.517 0 01-2.162.585A1.552 1.552 0 014.62 13H3.39l-.02.04a1.532 1.532 0 01-1.36.82A1.455 1.455 0 011 13.47v1.55c.321.128.664.193 1.01.19a2.878 2.878 0 001.98-.8 2.962 2.962 0 003.99 0 2.854 2.854 0 002 .8c.364.002.724-.07 1.06-.21H11v-1.53zm0 4a1.49 1.49 0 01-1.02.39A1.552 1.552 0 018.6 17H7.37l-.02.04a1.517 1.517 0 01-2.162.585A1.552 1.552 0 014.62 17H3.39l-.02.04a1.532 1.532 0 01-1.36.82A1.455 1.455 0 011 17.47v1.55c.321.128.664.193 1.01.19a2.878 2.878 0 001.98-.8 2.962 2.962 0 003.99 0 2.854 2.854 0 002 .8c.364.002.724-.07 1.06-.21H11v-1.53zm0 4a1.49 1.49 0 01-1.02.39A1.552 1.552 0 018.6 21H7.37l-.02.04a1.517 1.517 0 01-2.162.585A1.552 1.552 0 014.62 21H3.39l-.02.04a1.532 1.532 0 01-1.36.82A1.455 1.455 0 011 21.47v1.55c.321.128.664.193 1.01.19a2.878 2.878 0 001.98-.8 2.962 2.962 0 003.99 0 2.854 2.854 0 002 .8c.364.002.724-.07 1.06-.21H11v-1.53zm12.42-.93l-2.92-5.48a1.616 1.616 0 00-1.41-.84 1.594 1.594 0 00-1.39.82v-1.48a1.205 1.205 0 00-2.26-.59l-1.27 2.28-.66.49a1.626 1.626 0 00-.65 1.24 1.73 1.73 0 00.53 1.37l3.54 3.59a5.9 5.9 0 004.16 1.73h.45a2.124 2.124 0 001.88-3.13zm-1.21 1.41a.774.774 0 01-.67.38h-.45a4.537 4.537 0 01-3.2-1.34l-3.56-3.61a.374.374 0 01-.12-.32.308.308 0 01.09-.23l.91-.66 1.14-2.05v.99a1.583 1.583 0 001.58 1.58h.41l.53-.98a.257.257 0 01.22-.14.262.262 0 01.22.13L20 17l-.99.53v1.44h-.02l.04.07 1.61-.85.3.57-.93.49v1.32l.09.17 1.48-.79.65 1.22a.775.775 0 01-.02.78z"
        fill=""
      />
    </svg>
  )
);
SvgSportsTriathlonNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgSportsTriathlonNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsTriathlonNormalSmall;
